// extracted by mini-css-extract-plugin
export default {"container":"CreateCategory_container__M7F18","sectionContainer":"CreateCategory_sectionContainer__5JDoF","inputSelect":"CreateCategory_inputSelect__fDXfA"};